var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideResidential({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Light-Pink-24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Glass",
    filter: "url(#filter0_bi_16_3620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9174 24.5143C15.7372 25.1619 14.2628 25.1619 13.0826 24.5143L4.35311 19.7242C3.54897 19.2829 3.54897 18.2171 4.35311 17.7758L13.0826 12.9857C14.2628 12.3381 15.7372 12.3381 16.9174 12.9857L25.6469 17.7758C26.451 18.2171 26.451 19.2829 25.6469 19.7242L16.9174 24.5143Z",
    fill: "white",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8572 24.4047C15.7145 25.0318 14.2855 25.0318 13.1428 24.4047L4.41324 19.6146C3.69559 19.2208 3.69559 18.2792 4.41324 17.8854L13.1428 13.0953C14.2855 12.4682 15.7145 12.4682 16.8572 13.0953L25.5868 17.8854C26.3044 18.2792 26.3044 19.2208 25.5868 19.6146L16.8572 24.4047Z",
    stroke: "url(#paint0_linear_16_3620)",
    strokeOpacity: 0.1,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Glass_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9174 20.7643C15.7372 21.4119 14.2628 21.4119 13.0826 20.7643L4.35311 15.9742C3.54897 15.5329 3.54897 14.4671 4.35311 14.0258L13.0826 9.23569C14.2628 8.5881 15.7372 8.5881 16.9174 9.23569L25.6469 14.0258C26.451 14.4671 26.451 15.5329 25.6469 15.9742L16.9174 20.7643Z",
    fill: "url(#paint1_linear_16_3620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9174 20.7643C15.7372 21.4119 14.2628 21.4119 13.0826 20.7643L4.35311 15.9742C3.54897 15.5329 3.54897 14.4671 4.35311 14.0258L13.0826 9.23569C14.2628 8.5881 15.7372 8.5881 16.9174 9.23569L25.6469 14.0258C26.451 14.4671 26.451 15.5329 25.6469 15.9742L16.9174 20.7643Z",
    fill: "url(#paint2_linear_16_3620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9174 20.7643C15.7372 21.4119 14.2628 21.4119 13.0826 20.7643L4.35311 15.9742C3.54897 15.5329 3.54897 14.4671 4.35311 14.0258L13.0826 9.23569C14.2628 8.5881 15.7372 8.5881 16.9174 9.23569L25.6469 14.0258C26.451 14.4671 26.451 15.5329 25.6469 15.9742L16.9174 20.7643Z",
    fill: "url(#paint3_linear_16_3620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9174 20.7643C15.7372 21.4119 14.2628 21.4119 13.0826 20.7643L4.35311 15.9742C3.54897 15.5329 3.54897 14.4671 4.35311 14.0258L13.0826 9.23569C14.2628 8.5881 15.7372 8.5881 16.9174 9.23569L25.6469 14.0258C26.451 14.4671 26.451 15.5329 25.6469 15.9742L16.9174 20.7643Z",
    fill: "url(#paint4_linear_16_3620)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Color",
    filter: "url(#filter1_bi_16_3620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9174 17.0143C15.7372 17.6619 14.2628 17.6619 13.0826 17.0143L4.35311 12.2242C3.54897 11.7829 3.54897 10.7171 4.35311 10.2758L13.0826 5.48569C14.2628 4.8381 15.7372 4.8381 16.9174 5.48569L25.6469 10.2758C26.451 10.7171 26.451 11.7829 25.6469 12.2242L16.9174 17.0143Z",
    fill: "white",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8572 16.9047C15.7145 17.5318 14.2855 17.5318 13.1428 16.9047L4.41324 12.1146C3.69559 11.7208 3.69559 10.7792 4.41324 10.3854L13.1428 5.59528C14.2855 4.96824 15.7145 4.96824 16.8572 5.59528L25.5868 10.3854C26.3044 10.7792 26.3044 11.7208 25.5868 12.1146L16.8572 16.9047Z",
    stroke: "url(#paint5_linear_16_3620)",
    strokeOpacity: 0.1,
    strokeWidth: 0.25
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bi_16_3620",
    x: 0,
    y: 8.75,
    width: 30,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_16_3620"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_16_3620",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.625
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_16_3620"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bi_16_3620",
    x: 0,
    y: 1.25,
    width: 30,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_16_3620"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_16_3620",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.625
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_16_3620"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16_3620",
    x1: 25.5469,
    y1: 24.4318,
    x2: 3.75,
    y2: 24.4318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD84DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FD6FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16_3620",
    x1: 25.3125,
    y1: 18.75,
    x2: 1.78309,
    y2: 12.8676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE82DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68E4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16_3620",
    x1: 26.25,
    y1: 14.9958,
    x2: 3.75,
    y2: 14.9958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7177EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_16_3620",
    x1: 26.25,
    y1: 14.9958,
    x2: 3.75,
    y2: 14.9958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A53BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#505EDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_16_3620",
    x1: 5.12999,
    y1: 9.09662,
    x2: 28.6574,
    y2: 55.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3574,
    stopColor: "#FE7B1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC2A01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_16_3620",
    x1: 25.5469,
    y1: 16.9318,
    x2: 3.75,
    y2: 16.9318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD84DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FD6FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideResidential);
export default __webpack_public_path__ + "static/media/side-residential.5c32f27267b21c54fef93cf55aa6e843.svg";
export { ForwardRef as ReactComponent };